import { SEARCH_CAT_STARTED, SEARCH_CAT_DONE, SEARCH_CAT_FAILED } from '../actions/actionTypes'

const initialState = {
  searchCatResult: {},
  fetching: false,
  error: ''
}

export const searchCategories = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_CAT_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case SEARCH_CAT_DONE: {
      return {
        ...state,
        searchCatResult: action.payload.data,
        fetching: false
      }
    }
    case SEARCH_CAT_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
